




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { humanTime, maskCPFCNPJ } from '@/utils/common'
import { ConviteUsuarioDiagnostico, ConviteUsuarioDiagnosticoReferencia } from '@/types/interfaces/ConviteUsuarioDiagnostico'

@Component
export default class CardConvitesDiagnostico extends Vue {
  @Prop({ default: null }) convites!: ConviteUsuarioDiagnostico[] | null
  @Prop({ default: '' }) erro!: string

  get hasConvites(): boolean {
    return !!this.convites && this.convites.length > 0
  }

  get labelStatus(): string {
    if (this.erro) {
      return 'Indisponível'
    }

    if (!this.hasConvites) {
      return 'Não encontrado'
    }

    return `Encontrado (${this.convites!.length})`
  }

  get corStatus(): string {
    if (this.erro) {
      return 'warning'
    }

    return this.hasConvites ? 'success' : 'grey'
  }

  linhasDoConvite(convite: ConviteUsuarioDiagnostico) {
    return [
      { label: 'Id', valor: convite.id },
      { label: 'Nome', valor: convite.nome },
      { label: 'E-mail', valor: convite.email },
      { label: 'CPF', valor: convite.cpf ? maskCPFCNPJ(convite.cpf) : '—' },
      { label: 'Tipo', valor: convite.tipoConvite },
      { label: 'Status', valor: convite.status.display },
      { label: 'Criado em', valor: this.formatarData(convite.createdOn) },
      { label: 'Criado por', valor: this.nomeOuId(convite.criadoPor) },
      { label: 'Válido até', valor: this.formatarData(convite.validoAte) },
      { label: 'Cadastro finalizado', valor: this.formatarData(convite.cadastroFinalizadoEm) },
      { label: 'Hospitais', valor: convite.hospitais.map(hospital => this.nomeOuId(hospital)).join(', ') || '—' },
    ]
  }

  nomeOuId(referencia: ConviteUsuarioDiagnosticoReferencia): string {
    return referencia.nome || referencia.id
  }

  formatarData(data: string | null): string {
    return data ? humanTime(data) : '—'
  }
}
